import React from "react";
import { Modal, Button, Typography, Row, Col } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import cbRedIcon from "../../assets/icons/pooling/cb-red.svg";
import cbGreenIcon from "../../assets/icons/pooling/cb-green.svg";
import { useSelector } from "react-redux";

const { Title, Text } = Typography;

const ConfirmationModal = ({
  isVisible,
  onCancel,
  onConfirm,
  poolId,
  poolClosedAt,
  priceToPay,
}) => {

  const { FinalPoolDetails } = useSelector((state) => state.autoPooling);
  
  return (
    <Modal
      open={isVisible}
      onCancel={onCancel}
      footer={null}
      centered={false}
      width={400}
      style={{ top: 20 }}
    >
      {/* Header with Icon and Title */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
        <CheckCircleOutlined style={{ fontSize: "24px", color: "#0CC876", marginRight: "12px" }} />
        <Title level={4} style={{ margin: 0 }}>
          Pool Succesfully Created
        </Title>
      </div>

      {/* Subheading in blue color */}
      <Text style={{ color: "#678DFF", fontSize: "14px", marginBottom: "24px", display: "block" }}>
        The pool has been created. Once all members accept the pool, you will be notified. Until then, sit back and relax.
      </Text>

      {/* Vertical Description of 3 Columns */}
      <Row style={{ marginBottom: "24px" }}>
        <Col span={12}>
          <Text style={{ fontWeight: 500, color: "#737373" }}>Pool ID</Text>
          <br />
          <Text>{FinalPoolDetails.pool_id || "N/A"}</Text>
        </Col>
        <Col span={12}>
          <Text style={{ fontWeight: 500, color: "#737373" }}>Pool Finalized</Text>
          <br />
          <div className="vessel-value">
            <img width={25} src={poolClosedAt < 0 ? cbRedIcon : cbGreenIcon} alt="CB Icon" />
            <Text style={{ color: poolClosedAt < 0 ? "#FB2F2F" : "#0CC876", fontWeight: 500 }}>{Math.abs(parseFloat((Math.trunc(parseFloat(poolClosedAt / 10 ** 6) * 10 ** 6) / 10 ** 6)?.toFixed(4))) || "N/A"} CB</Text>
          </div>
        </Col>
        {/* <Col span={8}>
          <Text style={{ fontWeight: 500, color: "#737373" }}>Price to Pay</Text>
          <br />
          <Text style={{ color: "#678DFF", fontWeight: 500 }}>€{(priceToPay/(10**6)).toFixed(2) || "N/A"}</Text>
        </Col> */}
      </Row>

      {/* Footer with Buttons */}
      <div style={{ textAlign: "right" }}>
        <Button onClick={onCancel} style={{ marginRight: "8px" }}>
          Close
        </Button>
        <Button onClick={onConfirm} style={{ marginRight: "8px" }}>
          View Pool History
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
